import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError, tap, switchMap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "./base.service";
import { CountryDataTimeline, CountryDataTimelineCommentDto } from "../models/countrydatatimeline";
import { ISecurityGroup } from "../interfaces/isecuritygroup";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

/**
 * @whatItDoes A service for anything item related
 *
 * @howToUse Inject the service
 */
@Injectable()
export class SecurityGroupService extends BaseService {
    /**
     * Constructor for service
     * @param http angular http module
     * @param toastr toastr manager
     * @param store ngrx store
     */
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    /**
     * Creates a security group
     * @param securityGroup the security group to create
     */
    create(securityGroup: ISecurityGroup): Observable<number> {
        return super.post(`/api/SecurityGroup`, securityGroup)
            .pipe(map((res: any) => {
                return res;
            }));
    }

    update(securityGroup: ISecurityGroup): Observable<boolean> {
        return super.put("/api/SecurityGroup", securityGroup)
        .pipe(map((res: any) => {
            // Since the API returns Ok() with no content, res will be null
            // If we reach this point, the request was successful (no error thrown)
            return true;
        }));
    }

    /**
     * Gets a specific security group by id
     * @param id
     */
    getSecurityGroup(id: number): Observable<ISecurityGroup> {
        return super.get(`/api/SecurityGroup/${id}`).pipe(map((res: any) => res as ISecurityGroup));
    }

    /**
     * Gets all security groups for a business function
     */
    getSecurityGroups(): Observable<ISecurityGroup[]> {
        return super.get("/api/SecurityGroup").pipe(map((res: any) => res as ISecurityGroup[]));
    }

}






